export const NOTIFICATION_SOUND_EVENTS = Object.freeze({
  NEW_MESSAGE: 'new_message',
  INCOMING_CHATS: 'incoming_chats',
  NEW_TICKETS_TO_HANDLE: 'new_tickets_to_handle',
  VISITORS_IN_QUEUE: 'visitors_in_queue',
  NEW_VISITORS: 'new_visitors',
  RETURNING_VISITORS: 'returning_visitors',
});

export const NOTIFICATION_SOUND_FILE_MAP = Object.freeze({
  [NOTIFICATION_SOUND_EVENTS.NEW_MESSAGE]: 'message',
  [NOTIFICATION_SOUND_EVENTS.INCOMING_CHATS]: 'incoming_chat',
  [NOTIFICATION_SOUND_EVENTS.NEW_TICKETS_TO_HANDLE]: 'new_tickets_to_handle',
  [NOTIFICATION_SOUND_EVENTS.VISITORS_IN_QUEUE]: 'queued_visitor',
  [NOTIFICATION_SOUND_EVENTS.NEW_VISITORS]: 'new_visitor',
  [NOTIFICATION_SOUND_EVENTS.RETURNING_VISITORS]: 'returning_visitor',
});

export const LEGACY_TONE_FILE_MAP = Object.freeze({
  ding: 'message',
  bell: 'message',
  chime: 'message',
  magic: 'message',
  ping: 'message',
  message: 'message',
  incoming_chat: 'incoming_chat',
  new_tickets_to_handle: 'new_tickets_to_handle',
  queued_visitor: 'queued_visitor',
  new_visitor: 'new_visitor',
  returning_visitor: 'returning_visitor',
});

export const DEFAULT_NOTIFICATION_SOUND_ENABLED = true;
export const DEFAULT_REPEAT_NEW_MESSAGE_SOUND_UNTIL_READ = false;

export const DEFAULT_NOTIFICATION_SOUND_PREFERENCES = Object.freeze({
  [NOTIFICATION_SOUND_EVENTS.NEW_MESSAGE]: true,
  [NOTIFICATION_SOUND_EVENTS.INCOMING_CHATS]: true,
  [NOTIFICATION_SOUND_EVENTS.NEW_TICKETS_TO_HANDLE]: true,
  [NOTIFICATION_SOUND_EVENTS.VISITORS_IN_QUEUE]: true,
  [NOTIFICATION_SOUND_EVENTS.NEW_VISITORS]: true,
  [NOTIFICATION_SOUND_EVENTS.RETURNING_VISITORS]: true,
});

export const sanitizeNotificationSoundPreferences = preferences => {
  const sanitized = { ...DEFAULT_NOTIFICATION_SOUND_PREFERENCES };
  if (
    !preferences ||
    typeof preferences !== 'object' ||
    Array.isArray(preferences)
  ) {
    return sanitized;
  }

  Object.keys(DEFAULT_NOTIFICATION_SOUND_PREFERENCES).forEach(key => {
    if (typeof preferences[key] === 'boolean') {
      sanitized[key] = preferences[key];
    }
  });

  return sanitized;
};

export const areNotificationSoundPreferencesEqual = (left = {}, right = {}) => {
  if (
    !left ||
    !right ||
    typeof left !== 'object' ||
    typeof right !== 'object' ||
    Array.isArray(left) ||
    Array.isArray(right)
  ) {
    return false;
  }

  const leftKeys = Object.keys(left).sort();
  const rightKeys = Object.keys(right).sort();

  if (leftKeys.length !== rightKeys.length) {
    return false;
  }

  const hasSameKeys = leftKeys.every((key, index) => key === rightKeys[index]);
  if (!hasSameKeys) {
    return false;
  }

  return leftKeys.every(key => left[key] === right[key]);
};
